<script lang="ts">
  import { TrustPilotFullStar, TrustPilotHalfStar } from '@athena-lib/Icons';
  import { getStars } from '@athena-lib/trustpilot';

  const {
    rating,
    color = 'default',
    class: sizeClass = 'h-6 w-6',
  }: { rating: number; color?: 'black' | 'default'; class?: string } = $props();
</script>

<div class="flex flex-row">
  {#each getStars(rating) as star}
    <div class="p-[1px]">
      {#if star === 'full'}
        <TrustPilotFullStar {color} {sizeClass} />
      {:else}
        <TrustPilotHalfStar {color} {sizeClass} />
      {/if}
    </div>
  {/each}
</div>
